// Helpers for the family-portal PIN verification session.
//
// When a visitor enters the correct PIN, the verifyFamilyPortalPin Cloud
// Function returns a short-lived session token. We keep it in sessionStorage
// (cleared when the tab closes) and send it with every loadFamilyPortal call
// so the server can confirm the PIN was actually entered before returning any
// story data. This is what makes the PIN a real access control rather than a
// cosmetic, client-only gate.

const keyFor = (token) => `portalSession:${token}`;

export function getPortalSession(token) {
  try {
    return sessionStorage.getItem(keyFor(token)) || null;
  } catch {
    return null;
  }
}

export function setPortalSession(token, sessionToken) {
  try {
    sessionStorage.setItem(keyFor(token), sessionToken);
  } catch {
    /* ignore storage errors (private mode, disabled storage, etc.) */
  }
}

export function clearPortalSession(token) {
  try {
    sessionStorage.removeItem(keyFor(token));
  } catch {
    /* ignore */
  }
}
